import * as React from 'react';

export default function Address(props) {
  const { width = 150, height = 150, primary } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 200">
      <defs>
        <clipPath id="clip-Address">
          <path d="M0 0H200V200H0z"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-Address)">
        <path
          fill="none"
          stroke="#020d88"
          strokeWidth="8"
          d="M100.002 2.998a75.53 75.53 0 00-75.454 75.445c0 20.209 12.243 46.158 36.389 77.129A410.248 410.248 0 0096.8 195.716a4.619 4.619 0 006.384 0 410.231 410.231 0 0035.873-40.144c24.147-30.97 36.391-56.92 36.391-77.129a75.53 75.53 0 00-75.446-75.445zm0 129.334a53.889 53.889 0 1153.89-53.889 53.889 53.889 0 01-53.889 53.889z"
          data-name="Path 61783"></path>
        <path
          fill="#fff"
          d="M97.137 45.882L63.274 15.088a4.619 4.619 0 00-6.208 0L23.18 45.882a4.621 4.621 0 00-.859 5.789 4.747 4.747 0 004.1 2.248h4.481v29.253a4.619 4.619 0 004.627 4.613h10.78a4.619 4.619 0 004.619-4.619V66.224a4.619 4.619 0 014.619-4.619h9.238a4.619 4.619 0 014.615 4.619v16.942a4.619 4.619 0 004.615 4.619H84.8a4.619 4.619 0 004.619-4.619V53.919H93.9a4.747 4.747 0 004.1-2.248 4.621 4.621 0 00-.852-5.789z"
          data-name="Path 61784"
          transform="translate(39.838 21.064)"></path>
        <path
          fill={primary}
          d="M97.137 45.882L63.274 15.088a4.619 4.619 0 00-6.208 0L23.18 45.882a4.621 4.621 0 00-.859 5.789 4.747 4.747 0 004.1 2.248h4.481v29.253a4.619 4.619 0 004.627 4.613h10.78a4.619 4.619 0 004.619-4.619V66.224a4.619 4.619 0 014.619-4.619h9.238a4.619 4.619 0 014.615 4.619v16.942a4.619 4.619 0 004.615 4.619H84.8a4.619 4.619 0 004.619-4.619V53.919H93.9a4.747 4.747 0 004.1-2.248 4.621 4.621 0 00-.852-5.789z"
          opacity="0.35"
          transform="translate(39.838 21.064)"></path>
      </g>
    </svg>
  );
}
